export default __webpack_public_path__ + "static/media/MPOL_19_mos.2d4b6211.wav";